import { ActivityIndicator } from "react-native";
import { useTranslation } from "react-i18next";

import { busyAria } from "../a11y";
import type { UiTheme } from "../theme";

export type LoadingIndicatorProps = {
  theme: UiTheme;
  /** Defaults to `ink2`, the muted spinner every existing callsite already
   *  used (Coach/CoachRhythmCard, Coach/CoachMaxesCard,
   *  Coach/EffortCoveragePanel, Progress/ProgressRecordsCard). */
  color?: string;
};

// <LoadingIndicator>: the "content not here yet" spinner a card renders in
// place of its body. Four callsites hand-rolled the identical
// `<ActivityIndicator accessibilityLabel={t("app.loading")} />` (a review on
// ProgressRecordsCard added `busy` there alone, PG-39); consolidated here so
// every one of them announces the same way, and the next one gets it for
// free. `app.loading` on purpose: a spinner has no per-card meaning to add,
// and the app already carries this one generic string in all 5 locales.
export function LoadingIndicator({ theme, color }: LoadingIndicatorProps) {
  const { t } = useTranslation();
  return (
    <ActivityIndicator
      color={color ?? theme.palette.ink2}
      accessibilityLabel={t("app.loading")}
      accessibilityState={{ busy: true }}
      // RNW drops accessibilityState: aria-busy is the half that reaches the
      // DOM (RN reads either, View.js `ariaBusy ?? accessibilityState.busy`).
      {...busyAria(true)}
    />
  );
}
